import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { UserStateService } from "@app/state/user-state.service";
import { LocalRepository } from "@shared/helper/local-repository";
import { htmlUrls } from "@shared/utils/router-paths";
import { ACCESS_TOKEN_KEY } from "constants/storage-keys";

export const unAuthorizeGuard: CanActivateFn = (): boolean => {

    const router: Router = inject(Router);
    const userStateService = inject(UserStateService);
    const isUserLoggedIn = inject(LocalRepository).getCookieItem(ACCESS_TOKEN_KEY) && userStateService.userData;

    if (isUserLoggedIn) {
        router.navigate([htmlUrls.feed]);
        return false;
    }
    else {
        return true;
    }

};

